export interface HealthEvent {
  event: string;
  'snowplow-event': SnowplowEvent[];
}

export interface SnowplowEvent {
  schema: string;
  data: SnowplowEventData;
}

export interface SnowplowEventData {
  event_name: string;
  event_properties?: EventProperties;
}

export type MethodHandler = Record<string, (body) => EventProperties | []>;

export type MethodProperties = Map<string, EventProperties>;

export type EventProperties = Array<EventProperty>;

export type EventProperty = { key: string; value: string | boolean };

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ValidationFields = { fieldToCheck: any; errorName: string };

export enum HealthMetricStatus {
  Ok = 'Ok',
  Exception = 'Exception',
  Error = 'Error',
  Warning = 'Warning',
}

export enum MethodCommands {
  CH = 'ch',
  CL = 'cl',
  SE = 'se',
  MI = 'mi',
  GR = 'gr',
}
